<template>
  <nav class="sidebar" aria-label="Primary">
    <div class="profile-hero">
      <el-avatar :size="80" :title="userName">
        <el-icon size="xxx-large" color="black"><UserFilled /></el-icon>
      </el-avatar>
      <div class="welcome">
        <div class="portal-label">{{ portalLabel }}</div>
        <div class="name">Welcome back</div>
        <div class="muted">{{ userName || 'User' }}</div>
      </div>
    </div>

    <el-menu
      class="nav-list"
      :default-active="activeKey"
      background-color="transparent"
      text-color="#fffbf5"
      active-text-color="#ffffff"
      @select="$emit('select', $event)"
    >
      <el-menu-item
        v-for="item in items"
        :key="item.key"
        :index="item.key"
      >
        <el-icon><component :is="item.icon" /></el-icon>
        <span class="label">{{ item.label }}</span>
        <el-badge
          v-if="item.badge !== undefined && item.badge !== null"
          :value="item.badge"
          class="badge"
          color="white"
        />
      </el-menu-item>
    </el-menu>

    <el-button class="logout" type="warning" plain @click="$emit('select', 'logout')">
      <el-icon><SwitchButton /></el-icon>&nbsp;
      Log out
    </el-button>
  </nav>
</template>

<script>
import { UserFilled } from '@element-plus/icons-vue'

export default {
  name: 'SidebarNav',
  components: { UserFilled },
  props: {
    userName: String,
    role: String,
    activeKey: { type: String, default: 'home' },
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    portalLabel() {
      if (this.role === 'Admin' || this.role === 'Owner') return 'Employee Portal'
      return 'Customer Portal'
    },
  },
}
</script>

<style scoped>
.sidebar {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  box-sizing: border-box;
  color: #fffbf5;
  font-family: "Roboto", "Segoe UI", sans-serif, "Helvetica Neue", Arial, system-ui, -apple-system;
}

.profile-hero {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
}

.portal-label {
  margin-bottom: 3px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.welcome .name {
  font-weight: 700;
  color: #fffbf5;
}

.welcome .muted {
  color: rgba(255,255,255,0.8);
  font-size: 0.9rem;
}

.nav-list {
  border-right: none;
}

.nav-list .el-menu-item {
  border-radius: 10px;
  margin-bottom: 8px;
  height: 54px;
  line-height: 54px;
  font-weight: 700;
  display: flex;
  align-items: center;
}

.label {
  flex: 1;
}

.badge {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  --el-badge-border-width: 0;
}

.badge :deep(.el-badge__content) {
  min-width: 14px;
  height: 20px;
  padding: 0 6px;
  font-size: 14px;
  color: #003831;
}

.logout {
  margin-top: auto;
  width: 100%;
  border-radius: 10px;
}
</style>
